module.exports = __webpack_public_path__ + "static/media/eitCol.4bb13ed1.png";